import { render, staticRenderFns } from "./HeaderUser.vue?vue&type=template&id=2ec3628a"
import script from "./HeaderUser.vue?vue&type=script&lang=js"
export * from "./HeaderUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports